export default __webpack_public_path__ + "madrid-34a06ed1eeed7a0a61fa15aebaac6455.bundle.jpg";